// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3Ud1i","options":"AnswerScale_options__35zX2","selected":"AnswerScale_selected__2ku3x"};